import { Divider, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC, ReactElement } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	icon: ReactElement;
	label: string;
	text: string;
	onClick: () => void;
	hideDivider?: boolean;
};

export const ActivitiesFiltersItem: FC<Props> = ({
	icon,
	label,
	text,
	onClick,
	hideDivider,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const value = text ? text : t(Resources.Activity.Filters.Empty);

	return (
		<Stack direction="column">
			<Stack
				direction={"row"}
				justifyContent={"space-between"}
				height={48}
				onClick={onClick}
				sx={{ cursor: "pointer" }}
				gap={1.2}
			>
				<Stack direction="row" gap={1.2} alignItems={"center"}>
					{icon}
					<Typography
						variant="deprecatedBody1"
						color={theme.palette.deprecated.grey[500]}
					>
						{label}
					</Typography>
				</Stack>

				<Stack
					direction={"row"}
					gap={1.2}
					alignItems={"center"}
					justifyContent={"flex-end"}
				>
					<Typography
						variant="deprecatedBody1"
						color={theme.palette.deprecated.grey[500]}
						width="calc(100% - 28px)"
						sx={{
							display: "-webkit-box",
							WebkitBoxOrient: "vertical",
							WebkitLineClamp: 2,
							overflow: "hidden",
						}}
					>
						{value}
					</Typography>
					<ChevronRight size={16} cursor={"pointer"} />
				</Stack>
			</Stack>
			{!hideDivider && (
				<Divider
					sx={{
						borderWidth: 1,
						borderColor: theme.palette.deprecated.grey[100],
						marginBlock: "8px",
					}}
				/>
			)}
		</Stack>
	);
};
